export default __webpack_public_path__ + "static/media/workspace.f231a46b.svg";